import React, {useEffect, useState} from "react";
import Header from "../../components/Header";
import "./Profile.scss";
import Footer from "../../components/Footer";
import Button from "react-bootstrap/Button";
import ProfileComponent from "../../components/Profile/ProfileComponent";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

function Subscriptions() {
    useEffect(() => {
        document.title = "Geoticket - Iscrizioni";
    }, []);
    const navigate = useNavigate();

    const [user, setUser] = useState({
        has_newsletter: false,
    });
    useEffect(() => {
        global.permission().then((user) => {
            setUser(user);
        }).catch(error => {
            console.log(error);
            navigate(`/login`);

        });
    }, [navigate]);

    let subscribeNewsletter = () => {
        fetch(global.route.setNewsLetter, {
            method: "post", credentials: 'include',
            body: global.getFormData({
                has_newsletter: true,
            })
        }).then(response => {
            if (response.status !== 200) {
                global.catchError(response);
            } else {
                response.json().then(response => {
                    setUser(response.user);
                    toast.success("Iscrizione effettuata con successo!");
                });
            }
        })
    }

    return (
        <div>
            <Header/>
            <div className="container container-profile" style={{paddingTop: 86, minHeight: "100vh"}}>
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <ProfileComponent/>
                    </div>
                    <div className="col-md-8 mb-4">
                        <div className="card">
                            <div className="card-body">
                                <h4>Newsletter</h4>
                                <p>Unisciti oggi alla nostra newsletter per ricevere i migliori aggiornamenti sulle
                                    nostre attività.</p>
                                <div className="d-flex justify-content-center">
                                    {user.has_newsletter ? (
                                            <Button className={"btn-orange"} disabled={true}>Sei già iscritto</Button>) :
                                        <Button className={"btn-orange"}
                                                onClick={() => subscribeNewsletter()}>Iscriviti</Button>}
                                </div>
                            </div>
                        </div>
                        <div className="card card-subscription mt-4">
                            <div className="card-body">
                                <h4>Geoticket+</h4>
                                <p>Iscriviti a Geoticket+ per ottenere la migliore esperienza dalla tua escursione!</p>
                                <div className="d-flex justify-content-center">
                                    <Button variant={"light"}>Ottieni Geoticket+</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Subscriptions;